import React from 'react'
import { IconProps } from '../../../common/types'

const TemplateIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.25em"
      height="1.25em"
      viewBox="0 0 2048 2048"
    >
      <path
        fill="#000"
        d="M1668 129h124v1919H256V129h126V0h128v129h258V0h128v129h258V0h128v129h258V0h128zm-4 1791V257H384v1663zM1408 513v128H640V513zM640 1666v-128h768v128zm0-513v-128h768v128z"
      />
    </svg>
  )
}

export default TemplateIcon
